const shop = {
  init: () => {
    window.theme = window.theme || {};

    window.calcNavHeight = function (){
      // Calculates the padding on main to accommodate fixed nav

      if (!document.body.classList.contains('suffix-traceability-lp'))
      {
        const height = $('#shopify-section-header').outerHeight();
        $('main').css("padding-top", height)
      }

    }

    theme.config = {
      hasSessionStorage: true,
      hasLocalStorage: true,
      isTouch:
        "ontouchstart" in window ||
        (window.DocumentTouch && window.document instanceof DocumentTouch) ||
        window.navigator.maxTouchPoints ||
        window.navigator.msMaxTouchPoints
          ? true
          : false,
      isIpad:
        /ipad/.test(window.navigator.userAgent.toLowerCase()) ||
        (window.navigator.platform === "MacIntel" &&
          window.navigator.maxTouchPoints > 1),
      stickyHeader: false,
      recentlyViewed: [],
    };

    theme.recentlyViewed = {
      recent: {}, // will store handle & url of recent products,
      productInfo: {}, // will store product data to reduce API calls
    };
  },
};

export default shop;
